'use client';

import React, { FC } from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import Button from '../Button/Button';

import { StarIcon } from '@/public/icons';
import { devices } from '@/styles/breakpoints';
import { TitleH2 } from '@/styles/typography';
import { RegularText } from '@/styles/typography';

interface IProps {
  item: object;
  revert?: boolean;
}

export const FullArticle: FC<IProps> = ({
  item,
  revert = false,
  showButton = true,
}) => {
  return (
    <Wrapper $revert={revert}>
      <ImageWrapper>
        <Image
          width={536}
          height={620}
          alt={item.image.alt}
          src={item.image.path}
        />
      </ImageWrapper>
      <ContentWrapper>
        <Title>{item.title}</Title>
        <RegularText>{item.description}</RegularText>
        {!!item?.second_description && (
          <RegularText>{item.second_description}</RegularText>
        )}
        <ListItems>
          {item.item.map((item, idx) => (
            <Item key={idx}>
              <ItemIcon>
                <StarIcon />
              </ItemIcon>

              <ItemContent>
                {!!item?.title && <p className="list-title">{item.title}</p>}

                <RegularText>{item.description}</RegularText>
              </ItemContent>
            </Item>
          ))}
        </ListItems>
        {showButton && (
          <ButtonWrapper>
            <Button
              onClick={() =>
                window.open('https://app.orcatec.com/auth/signup', 'e_blank')
              }
              fullWidth={true}
              variant="secondary"
            >
              <p>Try Orcatec For Free</p>
            </Button>
          </ButtonWrapper>
        )}
      </ContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.article<{ $revert: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  @media only screen and ${devices.desktop} {
    flex-direction: ${(props) => (props.$revert ? 'row-reverse' : 'row')};
    gap: 56px;
  }
`;
const ImageWrapper = styled.div`
  width: 100%;
  text-align: center;
  & img {
    width: 100%;
    height: auto;
    max-width: 536px;
    max-height: 620px;
    margin: 0 auto;
    border-radius: 10px;
  }
`;
const ContentWrapper = styled.div`
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  /* @media only screen and ${devices.desktop} {
    padding: 0 56px;
  } */
`;

const ButtonWrapper = styled.div`
  width: 100%;
  padding-top: 10px;
  @media only screen and ${devices.desktop} {
    width: 100%;
    max-width: 180px;
  }
`;

const Title = styled(TitleH2)`
  text-align: left;
  @media only screen and ${devices.desktop} {
    line-height: 46px;
  }
`;

const ListItems = styled.ul`
  padding: 0;
  list-style: none;
  /* margin-left: -6px; */
`;

const Item = styled.li`
  display: grid;
  grid-template-columns: 30px auto;
  align-items: start;
  margin-bottom: 16px;
`;

const ItemIcon = styled.div`
  padding-top: 2px;
`;
const ItemContent = styled.div`
  & .list-title {
    font-family: var(--font-roboto);
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    margin-bottom: 8px;
  }
`;
